<style scoped>
.schedule-tab {
  display: table;
  width: 100%;
  padding: 20px 0;
  text-align: center;
  user-select: none; 
}

.schedule-tab .day-name {
  text-align: center;
}

.schedule-tab .day-name .schedule-cell {
  padding: 10px;
}

.schedule-tab .time-name p {
  position: relative;
  top: 3px;
  margin: 0;
}

.schedule-row {
  display: table-row;
}

.schedule-cell {
  display: table-cell;
  min-width: 10%;
  padding: 3px;
}

.loader-block {
  margin-top: 50px;
}

.warning-close-checkbox-block {
  padding: 10px 0 0 70px;
}
</style>

<template>
<div>
  <div class="col-12 loader-block" v-if="loader">
    <loader-component></loader-component>
  </div>
  <div class="col-12 row" v-if="!loader">
    <div class="col-12 row input-setting-block">
      <div class="offset-1 col-1 elips"></div>
      <div class="col-2 item-name">
        Закрывать при тревоге
      </div>
      <div class="col-7 warning-close-checkbox-block">
        <input  id="warning-close"
                v-model="warning_close_status" @change="changeWarningClose()" type="checkbox" autocomplete="off">
        <label for="warning-close">.</label>
      </div>
      <div class="offset-4 col-7 text-info-after-input-block">
        <p>Закрытие крана при тревоге датчиков</p>
      </div>
    </div>
    <div class="schedule-tab">
      <div class="schedule-row day-name">
        <div class="schedule-cell"></div>
        <div class="schedule-cell">ПН</div>
        <div class="schedule-cell">ВТ</div>
        <div class="schedule-cell">СР</div>
        <div class="schedule-cell">ЧТ</div>
        <div class="schedule-cell">ПТ</div>
        <div class="schedule-cell">СБ</div>
        <div class="schedule-cell">ВС</div>
      </div>
      <div class="schedule-row" v-for="(schedule_row, index) in getSchedule" :key="index">
        <div class="schedule-cell time-name">
          <p>{{schedule_row.time_text}}</p>
        </div>
        <div class="schedule-cell">
          <day-time-component :status="schedule_row.day_status_data[0]" :day="0" :change_action="addActionToSchedule" :time="schedule_row.time_index" :id_faucet="id_faucet"></day-time-component>
        </div>
        <div class="schedule-cell">
          <day-time-component :status="schedule_row.day_status_data[1]" :day="1" :change_action="addActionToSchedule" :time="schedule_row.time_index" :id_faucet="id_faucet"></day-time-component>
        </div>
        <div class="schedule-cell">
          <day-time-component :status="schedule_row.day_status_data[2]" :day="2" :change_action="addActionToSchedule" :time="schedule_row.time_index" :id_faucet="id_faucet"></day-time-component>
        </div>
        <div class="schedule-cell">
          <day-time-component :status="schedule_row.day_status_data[3]" :day="3" :change_action="addActionToSchedule" :time="schedule_row.time_index" :id_faucet="id_faucet"></day-time-component>
        </div>
        <div class="schedule-cell">
          <day-time-component :status="schedule_row.day_status_data[4]" :day="4" :change_action="addActionToSchedule" :time="schedule_row.time_index" :id_faucet="id_faucet"></day-time-component>
        </div>
        <div class="schedule-cell">
          <day-time-component :status="schedule_row.day_status_data[5]" :day="5" :change_action="addActionToSchedule" :time="schedule_row.time_index" :id_faucet="id_faucet"></day-time-component>
        </div>
        <div class="schedule-cell">
          <day-time-component :status="schedule_row.day_status_data[6]" :day="6" :change_action="addActionToSchedule" :time="schedule_row.time_index" :id_faucet="id_faucet"></day-time-component>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import loader from './loader.vue'
import dayTime from './schedule-mode-day-time.vue'

export default {
  created() {
    updateSchedule(this)
  },
  components: {
    'loader-component': loader,
    'day-time-component': dayTime
  },
  watch: {
    // warning_close_status: function (this_close_status, old_close_status) {
    //   if (old_close_status != null && this_close_status != old_close_status) {
    //     saveCloseStatus(this_close_status, this)
    //   }
    // }
  },
  data() {
    return {
      schedule: null,
      warning_close_status: null,
      loader: true,
      update_schedule_interval: null,
      actions_for_save: []
    }
  },
  props: ['id_faucet'],
  methods: {
    changeWarningClose: function(){
        saveCloseStatus(this.warning_close_status, this)
    },
    getCellClass: function (faucet_status) {
      if (faucet_status == 'open') {
        return 'open-faucet'
      } else {
        return 'close-faucet'
      }
    },
    changeScheduleStatus(time, day) {

      if (!!this.schedule[time].day_status_data[day]) {
        if (this.schedule[time].day_status_data[day] == 'close') {
          this.schedule[time].day_status_data[day] = 'open'
        } else {
          this.schedule[time].day_status_data[day] = 'close'
        }
        // console.log(this.schedule[time].day_status_data[day])
      }
    },
    addActionToSchedule: function (week_day, time, action) {
        this.actions_for_save.push({
            'week_day':week_day,
            'time': time,
            'action': action
        })
        waitOtherScheduleActions(this, this.actions_for_save)
    }
  },
  computed: {
    getSchedule: function () {
      return this.schedule
    }
  },
  destroyed() {
      if (this.update_schedule_interval) {
          clearInterval(this.update_schedule_interval)
      }
  },
}

function updateSchedule(vue_obj) {
    GetScheduleModeData(vue_obj)
    vue_obj.update_schedule_interval = setInterval(() => {
        GetScheduleModeData(vue_obj)
    }, config.UPDATE_PERIOD);
}

function GetScheduleModeData(vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_faucet', vue_obj.id_faucet)

  axios({
      method: 'POST',
      url: config.API_HOST + '/faucets/get_schedule_mode_faucet',
      data: post_data
    })
    .then(function (response) {
    //   console.log(response.data)
      if (!!response.data.schedule) {
        var schedule_for_view = []
        var half_hour = true
        var hour = 0
        for (let schedule_time_index = 0; schedule_time_index <= 47; schedule_time_index++) {
          var schedule_time_data = {}
          var hour_text = hour.toString()
          if (hour_text.length == 1) {
            hour_text = '0' + hour_text
          }
          if (half_hour) {
            schedule_time_data.time_text = hour_text + ':00 - ' + hour_text + ':30'
            half_hour = false
          } else {
            var second_hour = (hour + 1).toString()
            if (second_hour.length == 1) {
                second_hour = '0' + second_hour
            }
            schedule_time_data.time_text = hour_text + ':30 - ' + second_hour + ':00'
            half_hour = true
          }
          schedule_time_data.time_index = schedule_time_index
          schedule_time_data.day_status_data = []
          for (let shedule_day_index = 0; shedule_day_index < 7; shedule_day_index++) {
            if (typeof response.data.schedule[shedule_day_index][schedule_time_index] !== 'undefined') {
              schedule_time_data.day_status_data[shedule_day_index] = response.data.schedule[shedule_day_index][schedule_time_index]
            }
          }
          schedule_for_view.push(schedule_time_data)
          if (half_hour) {
            hour += 1
          }
        }
        vue_obj.schedule = schedule_for_view
      }
      if (typeof response.data.warning_close !== 'undefined') {
        vue_obj.warning_close_status = response.data.warning_close
      }
      vue_obj.loader = false
    })
    .catch(function (error) {
      console.log(error.response.data)
    })
}

function saveCloseStatus(new_close_status, vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_faucet', vue_obj.id_faucet)
  post_data.set('warning_close', new_close_status)

  axios({
      method: 'POST',
      url: config.API_HOST + '/faucets/change_warning_close',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
    })
    .catch(function (error) {

    })
}

function waitOtherScheduleActions (vue_obj, actions) {
    setTimeout(() => {
        if (vue_obj.actions_for_save == actions) {
            saveScheduleAction(vue_obj, actions)
            vue_obj.actions_for_save = []
        }
    }, 5000);
}

function saveScheduleAction(vue_obj, actions) {
    const post_data = new URLSearchParams();
    post_data.append("token", localStorage.token);
    post_data.append('id_faucet', vue_obj.id_faucet)
    var actions_for_request = []
    actions.forEach(element => {
        actions_for_request.push(element.week_day + ',' + element.time + ',' + element.action )
    });
    actions_for_request = actions_for_request.join( '&' )
    post_data.append('actions', actions_for_request)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/change_schedule',
            data: post_data
        })
        .then(function (request) {
            // console.log(request)
        })
        .catch(function (error) {
            if (!!error.response.data.exception) {
                vue_obj.faucet_name_msg = error.response.data.exception
            }
            if (this.faucet_day_status == 'close') {
                this.faucet_day_status = 'open'
            } else if (this.faucet_day_status == 'open') {
                this.faucet_day_status = 'close'
            }
        })
}
</script>



// WEBPACK FOOTER //
// src/components/elements/schedule-mode.vue